<div *ngIf="loading" class="spinner-wrapper" fxLayoutAlign="center center">
  <mat-spinner></mat-spinner>
</div>
<div [hidden]="loading">
  <router-outlet></router-outlet>
</div>
